// Centralized z-index management
// See docs/z-index-depth-management.md for the rationale
// Adding a new layer means adding a new constant in the right position

// Grid-local layers (used by GridWord leaves — no stacking context on words)
let g = 1
export const gridIssueBadge = g++
export const gridIssueTooltip = g++

let d = g // Start above grid-local values
export const gridControls = d++  // Grid zoom/overlay controls
export const dragging = d++      // Dragged elements on grid
export const dropdown = d++      // Dropdown menus
export const modal = d++         // Modal overlays
export const debugPanel = d++    // Debug panel (can appear over modals)
